import React, {useEffect, useState} from 'react';
import {MainContent} from '../../../shared/grid/main-content/MainContentFeatures.js';
import {StackedSpacer} from '../../../shared/custom-features/spacer/StackedSpacer';
import {Card, CardContainer} from '../../../shared/elements/card/Card';
import {withTranslation} from 'react-i18next';
import {FormFile} from '../../../shared/form/form-control/FormFile.js';
import {Btn} from '../../../shared/elements/btn/Btn.js';
import errorHandler from '../../../util/errorHandler.js';
import {addMovements} from '../customers/customerTabs/endpoints.js';
import {ValidationErrorTxt} from '../../../shared/form/form-features/ValidationErrorTxt.js';
import {NotificationManager} from 'react-notifications';
import styled from 'styled-components';

const CustomerUploadTabView = ({selectedCustomer, t}) => {
    const [selectedFile, setSelectedFile] = useState(null);
    const [loading, setLoading] = useState(false);
    const [fileError, setFileError] = useState(null);

    const onUploadMovements = (event) => {
        setFileError(null);
        setSelectedFile(event.target.files[0]);
    };

    useEffect(() => {
        setSelectedFile(null);
        setFileError(null);
    }, [selectedCustomer]);

    const addValuesToDatabase = () => {
        setLoading(true);

        addMovements(selectedCustomer.customerId, selectedFile)
            .then((res) => {
                if (res.status == 200) {
                    NotificationManager.success(t('warehousing.ImportSuccessful'));
                }
            })
            .catch((e) => {
                setFileError(errorHandler(e.response.data, false, t));
            })
            .finally(() => {
                setLoading(false);
            });
    };

    return (
        <MainContent.Body>
            <Wrapper>
                <StackedSpacer space="md">
                    <Card color="primary">
                        <br />
                        <h3>{t('explanations.UploadMovementsAndStock')}</h3>
                        <ol>
                            <li>{t('explanations.JustNeedsExcel')}</li>
                        </ol>
                    </Card>
                    <FormFile
                        label={t('warehousing.UploadFile')}
                        accept=".xlsx"
                        onChange={onUploadMovements}
                        fileName={selectedFile && selectedFile.name}
                    />
                    {fileError && <ValidationErrorTxt>{t(`${fileError}`)}</ValidationErrorTxt>}
                    {selectedFile !== null && (
                        <Btn
                            type="button"
                            color="success"
                            onClick={addValuesToDatabase}
                            disabled={selectedFile == null}
                        >
                            {loading ? t('general.Busy') : t('warehousing.Import')}
                        </Btn>
                    )}
                </StackedSpacer>
            </Wrapper>
        </MainContent.Body>
    );
};

export default withTranslation()(CustomerUploadTabView);

const Wrapper = styled.div`
    padding: var(--space-lg);

    ${CardContainer} {
        border: 1px solid var(--primary);
    }
`;
